import React, { useEffect } from "react";
import { useFormikContext } from "formik";
import InputField from "../../forms/input-field";
import SelectField from "../../forms/select-field";
import { api } from "../../../redux/apis/api";

const StoreDetailsTab = ({ disabled = false, id }) => {
  const { setFieldValue } = useFormikContext();

  useEffect(() => {
    if (id) {
      api
        .get(`/store/getById?store_id=${id}`)
        .then((res) => {
          const data = res.data?.data?.[0];
          // The backend column is misspelled `corpet_area`; reading the correct
          // spelling returned undefined and overwrote the value the parent form
          // had already resolved, blanking the field on every tab visit.
          const carpetArea = data?.corpet_area ?? data?.carpet_area;
          if (carpetArea !== null && carpetArea !== undefined && carpetArea !== "") {
            setFieldValue("carpet_area", carpetArea);
          }
        })
        .catch((err) => {
          console.error("Failed to fetch store details:", err?.response?.data ?? err?.message);
        });
    }
  }, [id]);

  return (
    <div className="w-full 2xl:w-[40%] xl:w-[50%] lg:w-[60%] px-5 xl:px-10 mt-5">
      <SelectField
        isDisabled={disabled}
        placeholder="Select Property Type"
        options={propertyTypeOptions}
        label="Is Property Self-Owned or Rented"
        id="property_owned_type"
        name="property_owned_type"
        labelWidth="12.8rem"
      />
      {/* Read-only: rent comes from the backend. */}
      <InputField
        isDisabled={true}
        // isRequired={true}
        type="number"
        name="store_rent_per_month"
        placeholder="Enter Store Rent Per Month"
        label="Store Rent Per Month"
        labelWidth="12.8rem"
      />
      <InputField
        isDisabled={disabled}
        // isRequired={true}
        type="text"
        name="store_duration_concurrently"
        placeholder="Enter Store Duration Concurrently"
        label="Store Duration Concurrently"
        labelWidth="12.8rem"
      />
      <InputField
        isDisabled={disabled}
        // isRequired={true}
        type="number"
        name="store_sale_per_day"
        placeholder="Enter Store Sale Per Day"
        label="Store Sale Per Day"
        labelWidth="12.8rem"
      />
      <InputField
        isDisabled={disabled}
        // isRequired={true}
        type="number"
        name="store_medicine_sale"
        placeholder="Enter Store Medicine Sale"
        label="Store Medicine Sale"
        labelWidth="12.8rem"
      />

      <InputField
        isDisabled={disabled}
        // isRequired={true}
        type="number"
        name="store_otc_sale"
        placeholder="Enter Store OTC Sale"
        label="Store OTC Sale"
        labelWidth="12.8rem"
      />
    </div>
  );
};

export default StoreDetailsTab;
const propertyTypeOptions = [
  { label: "Self-Owned", value: "self_owned" },
  { label: "Rented", value: "rented" },
];
